import React from 'react';
import { ContractorCheckboxProps } from './types';
import { disableBodyScroll } from 'body-scroll-lock';
import type { BodyScrollOptions } from 'body-scroll-lock';
import Stars from './stars';
import { certificationImages } from '../../controllers/controller';
import { createDataLayerString } from '../../../helpers/helpers';

function ContractorCheckbox({
  formData,
  handleChange,
  review,
  certifications,
  modalId
}: ContractorCheckboxProps) {
  let certificationImagesArray: { facetName: string; iconUrl: string }[] = [];

  const formElement = document.querySelector(
    '.contractor-request-a-quote-form'
  );
  const dataCertificationImages = formElement?.getAttribute(
    'data-certification-images'
  );

  if (dataCertificationImages) {
    try {
      certificationImagesArray = JSON.parse(dataCertificationImages);
    } catch (error) {
      console.error('Error parsing certification images:', error);
    }
  } else if (certificationImages.length > 0) {
    certificationImagesArray = certificationImages;
  }

  const modal = document.querySelector<HTMLElement>(`#${modalId}`);

  const handleClick = () => {
    const options = {
      reserveScrollBarGap: true,
      allowTouchMove: (el: HTMLElement) => {
        return el.classList.contains('modal');
      }
    } as BodyScrollOptions;

    (modal as HTMLDialogElement)?.showModal();
    disableBodyScroll(modal as HTMLElement, options);
  };

  return (
    <div
      key={review.id}
      className="request-a-quote__content-reviews-checkbox field field--checkbox"
    >
      <input
        className="field__checkbox-input"
        type="checkbox"
        name={review.name}
        id={review.id}
        checked={
          (formData[review.name] as string[])?.length > 0
            ? (formData[review.name] as string[]).includes(review.id)
            : false
        }
        onChange={e => handleChange(e, review)}
      />
      <div className="field__checkbox-label-wrapper">
        <label className="field__checkbox-label" htmlFor={review.id}>
          <span className="field__checkbox-label-text">
            {review.contractorName}
          </span>
          {review.image && (
            <picture className="request-a-quote__content-reviews-image-wrapper">
              <img
                src={review.image}
                alt={review.imageAlt}
                width="50"
                height="33"
                className="request-a-quote__content-reviews-image"
              />
            </picture>
          )}
          <Stars
            rating={review.rating}
            numberOfReviews={review.numberOfReviews}
          />
          <span className="request-a-quote__content-reviews-city">{`${review.city}, ${review.state} - ${Number(review.distance).toFixed(1)} mi`}</span>
        </label>
        {certifications.certificates.length > 0 && (
          <>
            <div className="request-a-quote__content-reviews-certifications-heading-wrapper">
              <h3 className="request-a-quote__content-reviews-certifications-heading">
                {certifications.title}
              </h3>
              <button
                type="button"
                className="btn--tooltip btn--tooltip-alt"
                title={certifications.viewAllCertificationsLabel}
                onClick={handleClick}
                data-layer={createDataLayerString([
                  {
                    event: 'modal_interaction',
                    event_category: 'modals',
                    event_action: 'view',
                    event_attributes: {
                      modalName: 'certifications'
                    }
                  }
                ])}
              >
                <span className="sr-only">
                  {certifications.viewAllCertificationsLabel}
                </span>
              </button>
            </div>

            <ul className="request-a-quote__content-reviews-certifications-list">
              {certifications.certificates.map(certification => (
                <li
                  key={certification}
                  className="request-a-quote__content-reviews-certification"
                >
                  <img
                    src={
                      certificationImagesArray?.find(
                        (item: { facetName: string }) =>
                          item.facetName === certification
                      )?.iconUrl
                    }
                    alt={certification}
                    role="presentation"
                    className="request-a-quote__content-reviews__certification-icon"
                  />
                  <span className="request-a-quote__content-reviews__certification-name">
                    {certification}
                  </span>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
export default ContractorCheckbox;
